/**
 * Classes Service - API client for class sections, class-subject
 * assignment, and the subject catalog lookup
 */
import api from '../utils/api';

const classesService = {
  listClasses: async (params) => {
    try {
      return await api.get('/api/classes', { params });
    } catch (error) {
      console.error('Error fetching classes:', error);
      throw error;
    }
  },

  createClass: async (data) => {
    try {
      return await api.post('/api/classes', data);
    } catch (error) {
      console.error('Error creating class:', error);
      throw error;
    }
  },

  getClass: async (classId) => {
    try {
      return await api.get(`/api/classes/${classId}`);
    } catch (error) {
      console.error('Error fetching class:', error);
      throw error;
    }
  },

  updateClass: async (classId, data) => {
    try {
      return await api.put(`/api/classes/${classId}`, data);
    } catch (error) {
      console.error('Error updating class:', error);
      throw error;
    }
  },

  getClassStudents: async (classId) => {
    try {
      return await api.get(`/api/classes/${classId}/students`);
    } catch (error) {
      console.error('Error fetching class students:', error);
      throw error;
    }
  },

  listAllSubjects: async () => {
    try {
      return await api.get('/api/classes/subjects/all');
    } catch (error) {
      console.error('Error fetching subject catalog:', error);
      throw error;
    }
  },

  addSubjectToClass: async (classId, subjectId, academicTermId) => {
    try {
      return await api.post(`/api/classes/${classId}/subjects/${subjectId}`, {
        academic_term_id: academicTermId
      });
    } catch (error) {
      console.error('Error adding subject to class:', error);
      throw error;
    }
  },

  removeSubjectFromClass: async (classId, subjectId, academicTermId) => {
    try {
      return await api.delete(`/api/classes/${classId}/subjects/${subjectId}`, {
        params: { academic_term_id: academicTermId }
      });
    } catch (error) {
      console.error('Error removing subject from class:', error);
      throw error;
    }
  },

  // ---- Waitlist ----

  getWaitlist: async (classId) => {
    try {
      return await api.get(`/api/classes/${classId}/waitlist`);
    } catch (error) {
      console.error('Error fetching class waitlist:', error);
      throw error;
    }
  },

  offerWaitlistSeat: async (classId, entryId) => {
    try {
      return await api.post(`/api/classes/${classId}/waitlist/${entryId}/offer`, {});
    } catch (error) {
      console.error('Error offering waitlist seat:', error);
      throw error;
    }
  },

  cancelWaitlistEntry: async (classId, entryId) => {
    try {
      return await api.delete(`/api/classes/${classId}/waitlist/${entryId}`);
    } catch (error) {
      console.error('Error cancelling waitlist entry:', error);
      throw error;
    }
  }
};

export default classesService;
